// Module
var code = "<template> <require from=\"./modal-header.scss\"></require> <slot></slot> </template> ";
// Exports
module.exports = code;